import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { DocumentCategoryResultDto } from '../../shared-document-module/_models/documents-editor/document-category-result-dto';
import { DocumentSubCategoryResultDto } from '../../shared-document-module/_models/documents-editor/document-subcategory-result-dto';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
const ɵ0 = () => DocumentCategoryResultDto, ɵ1 = () => DocumentSubCategoryResultDto, ɵ2 = () => KeyValueResultDto;
export class UploadEmailDocumentEditorResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], UploadEmailDocumentEditorResultDto.prototype, "categories", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], UploadEmailDocumentEditorResultDto.prototype, "subCategories", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], UploadEmailDocumentEditorResultDto.prototype, "fileTypes", void 0);
export { ɵ0, ɵ1, ɵ2 };
